import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportManageAcquiredAssets } from '@api/manageAcquiredAssets';

import { TExportAssetsDTO } from '@interfaces/assets/dto/assetsDTO';

import { ESnackbarTypes } from '@enums/common';

import { EXPORT_ACQUIRED_ASSETS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportAcquiredAssets = () => {
	const dispatch = useAppDispatch();

	const {
		mutate: handleExportAcquiredAssets,
		isLoading: isLoadingExportAcquiredAssets,
	} = useMutation<TExportAssetsDTO>({
		mutationKey: [EXPORT_ACQUIRED_ASSETS],
		mutationFn: exportManageAcquiredAssets,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
		refetchOnWindowFocus: false,
	});

	return {
		handleExportAcquiredAssets,
		isLoadingExportAcquiredAssets,
	};
};
